import { createTypes } from 'redux-action-creator';
import { Action } from '../../../types';
import { Resolution } from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  ['LOAD_SUCCESS'],
  'WAIVER_WORK_ITEM_RESOLUTIONS',
);

export function receiveWaiverWorkItemResolutions(
  resolutions: Resolution[],
): Action<Resolution[]> {
  return {
    type: types.LOAD_SUCCESS,
    response: resolutions,
  };
}
